export const MunicipioUfSchema = '&id, value, display, regiao, updatedAt, isSynced';

export const municipioUfMapper = {
  toEntity: (apiData) => {
    return apiData.map(municipio => ({
      id: municipio.ID,
      value: municipio.VALUE,
      regiao: municipio.REGIAO,
      display: municipio.DISPLAY,
      updatedAt: new Date().getTime(),
      isSynced: true
    }));
  }
};
